// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://yzszlbmliygajtnonupr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl6c3psYm1saXlnYWp0bm9udXByIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQzNzAwODYsImV4cCI6MjA0OTk0NjA4Nn0.-zqHxkC_xFojQLAfb8xWHTFHoLyOTxGpEeI-21hnL_s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});